import { Action, createReducer, on } from '@ngrx/store';
import { Status } from '../../../models/status';
import {
  initializeFlightReshopServiceState,
  loadSliceBySliceReshopResults,
  loadSliceBySliceReshopResultsComplete,
  resetFlightReshopServiceState,
  setSessionId,
  setSolutionSetId,
} from './flight-reshop-service.actions';
import { initialFlightReshopServiceState } from './flight-reshop-service.state';

const featureReducer = createReducer(
  initialFlightReshopServiceState,
  on(initializeFlightReshopServiceState, (state) => ({ ...state, ...initialFlightReshopServiceState })),
  on(loadSliceBySliceReshopResults, (state) => ({
    ...state,
    sliceBySliceResults: null,
    status: Status.UPDATING,
    error: null,
  })),
  on(loadSliceBySliceReshopResultsComplete, (state, { response, error }) => ({
    ...state,
    sliceBySliceResults: response ?? null,
    status: Status.STABLE,
    error,
  })),
  on(setSessionId, (state, { sessionId }) => ({
    ...state,
    sessionId,
  })),
  on(setSolutionSetId, (state, { solutionSetId }) => ({
    ...state,
    solutionSetId,
  })),
  on(resetFlightReshopServiceState, (state) => ({ ...state, ...initialFlightReshopServiceState }))
);

export function flightReshopServiceReducer(state = initialFlightReshopServiceState, action: Action) {
  return featureReducer(state, action);
}
